import axios from 'axios';
import { snakeCase } from 'change-case';
import merge from 'lodash/merge.js';

import User from '@/store/modules/users/User.js';
import Collection from '@/store/quill/Collection.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';
import { promiseError } from '@/store/utilities/Helpers.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

const collectionHelpers = EdverumTable.collection('user');

export default merge(Collection('Users', User), {
    state: {
        sort: {
            external_id: null,
            first_name: null,
            last_name: 'asc',
            email: null,
            created_at: null,
            updated_at: null,
        },
    },

    getters: {
        ...collectionHelpers.getters,
    },

    actions: {
        clearSort: collectionHelpers.actions.clearSort,
        paginateAndFetch: collectionHelpers.actions.paginateAndFetch,

        fetch: collectionHelpers.actions.fetch(({ context, queryBuilder }) => {
            const { getters, rootGetters } = context;

            queryBuilder
                .include(['roles', 'statuses'])
                .sort(getters.queryBuilderSorting)
                .setPagination(getters.paginate);

            if (rootGetters['UsersView/hasQuery']) {
                queryBuilder.raw({
                    search: rootGetters['UsersView/searchQuery'],
                });
            }
        }),

        fetchOne: collectionHelpers.actions.fetchOne(({ queryBuilder }) => {
            queryBuilder.include([
                'roles',
                'visibleEnrollments.course',
                'visibleEnrollments.roles',
                'visibleEnrollments.statuses',
                'userGroups.role',
                'userGroups.group',
                'statuses',
            ]);
        }),

        addUser: collectionHelpers.actions.addModel(({ queryBuilder }) => {
            queryBuilder.include(['roles']);
        }),

        updateUser: collectionHelpers.actions.updateModel(),

        async updateUserRole(context, payload) {
            const query = new QueryBuilder(`user/${payload.id}/roles`).toUrl();

            try {
                const { data } = await axios.put(query, payload);

                context.commit('UPDATE_MODEL', data.data);
            } catch (error) {
                promiseError({
                    key: `${snakeCase('users')}_update_error`,
                    context,
                });

                return error;
            }
        },

        removeChecked: collectionHelpers.actions.removeChecked(),
    },

    mutations: {
        ADD_MODEL: collectionHelpers.mutations.ADD_MODEL,
        UPDATE_MODEL: collectionHelpers.mutations.UPDATE_MODEL,
        CLEAR_SORTING: collectionHelpers.mutations.CLEAR_SORTING,
    },
});
